import { StateStorage } from 'zustand/middleware';
import { ResponseError, api } from '@nexelem/api';

const lastKnownState = new Map<string, string>();

export const umStorage: StateStorage = {
  getItem: async (name: string): Promise<string | null> => {
    const result =
      (await api.getUmConfigurationKey({ path: name }).catch((error: unknown) => {
        if (error instanceof ResponseError && error.response?.status === 404) {
          return null;
        }
        throw error;
      })) || null;

    lastKnownState.set(name, result);

    return result;
  },
  setItem: async (name: string, value: string): Promise<void> => {
    if (lastKnownState.get(name) !== value) {
      const result = await api.postUmConfigurationKeySave({ path: name, body: value });
      lastKnownState.set(name, value);
      return result;
    }
  },
  removeItem: async (name: string): Promise<void> => {
    await api.deleteUmConfigurationKeyDelete({ path: name });
  },
};
